import { render, staticRenderFns } from "./BlockRulesEdit.vue?vue&type=template&id=454977d5&"
import script from "./BlockRulesEdit.vue?vue&type=script&lang=ts&"
export * from "./BlockRulesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports